import React, { useEffect } from "react";
import "./timeless-design.css";
import { Link, useNavigate } from "react-router-dom";
import Explore_btn from "../../common-components/common-buttons/explore-button/Explore_btn";
import { useDispatch, useSelector } from "react-redux";
import { getAllBanner, getOfferBanner } from "../../../features/home/homeSlice";
import CryptoJS from "crypto-js";
const Timeless_design = () => {
  const dispatch = useDispatch();

  const SECRET_KEY = "my_secret_key_123";
  const allbanners = useSelector((state) => state.home.offerbanners);
  useEffect(() => {
    dispatch(getOfferBanner({ banner_type_id: 3 }));
  }, []);

  const navigate = useNavigate();
  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };

  const handleCategory = (gender) => {
    console.log(gender, "gender gender gender");

    const token = encryptData(gender);
    navigate(`/all-products?category=${encodeURIComponent(token)}`);
  };

  return (
    <>
      <section className="Timeless_design_sec">
        <div className="container">
          <div className="banner-div">
            <Link to="#">
              <img
                className="banner-img"
                src={process.env.REACT_APP_IMAGE_URL + allbanners?.image}
              />
            </Link>

            <div className="btnpos">
              <Explore_btn
                name="Explore Now"
                onClick={() => {
                  if (allbanners?.p_category) {
                    handleCategory({
                      id: allbanners?.p_category?.id,
                      name: allbanners?.p_category?.name,
                    });
                  } else {
                    navigate("/all-products");
                  }
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Timeless_design;
